<script setup>
import { ref } from 'vue'
import { useAuthStore } from '@/stores/auth'
import { useMessagesStore } from '@/stores/messages'
import { api } from '@/utils/axios'

const fileInput = ref(null)
const authStore = useAuthStore()
const messages = useMessagesStore()

const handleFileChange = async (event) => {
  const file = event.target.files[0]
  if (!file) return

  // Check file type
  if (!file.type.startsWith('image/')) {
    messages.error('Prosím vyberte obrázek')
    return
  }

  // Check file size (max 2MB)
  if (file.size > 800 * 1024) {
    messages.error('Obrázek je příliš velký (max 800kB)')
    return
  }

  const formData = new FormData()
  formData.append('file', file)

  try {
    await api.post('/avatar', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })

    // Update avatar URL in store
    await authStore.getAvatarURL()
    messages.success('Avatar updated')
  } catch (error) {
    messages.error('Error uploading avatar: ' + error.message)
  }

  // Reset input
  event.target.value = ''
}
</script>

<template>
  <div class="avatar-upload">
    <input type="file" ref="fileInput" @change="handleFileChange" accept="image/*" class="hidden" />
    <button @click="$refs.fileInput.click()" class="upload-btn">Change avatar</button><br />
    256px, 800kB
  </div>
</template>

<style scoped>
.avatar-upload {
  margin: 0ex 0ex;
}

.hidden {
  display: none;
}

.upload-btn {
  background: #6655aa;
  color: white;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9em;
  transition: background-color 0.2s;
}

.upload-btn:hover {
  background: #357abd;
}
</style>
